import React from 'react';
interface ScrollButtonProps {
  children: React.ReactNode;
  className?: string;
}
export function ScrollButton({
  children,
  className = ''
}: ScrollButtonProps) {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('compra');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <button onClick={scrollToPricing} className={`bg-gold-500 hover:bg-gold-400 text-navy-900 font-bold py-4 px-8 rounded-full shadow-[0_0_20px_rgba(212,160,23,0.4)] hover:shadow-[0_0_30px_rgba(212,160,23,0.6)] transition-all duration-300 transform hover:-translate-y-1 ${className}`} data-id="element-210">
      {children}
    </button>;
}